<template>

	<div>

    <!-- <MobileMenu ref="mobileMenu" v-if="isMobile"/> -->
  
		<router-view/>

		<Footer v-if="showFooter"/>

    <Back/>
		
	</div>
  
</template>

<style type="text/css">
  .pointer { cursor: pointer !important; }
</style>

<script>
import Back from '@/components/UI/Back'
import Footer from '@/components/UI/Footer'
//import MobileMenu from '@/components/UI/MobileMenu'

import utility from '@/mixins/utility'

import { mapGetters } from 'vuex'

export default {
  name: 'App',

  mixins: [ utility ],

  components:
  {
    Back,
    Footer,
    //MobileMenu
  },

  data: () => ({
    //
  }),

  computed:
  {
    ...mapGetters({
      isLoading: 'ui/isLoading',
      showFooter: 'ui/showFooter'
    })
  },

  mounted()
  {
    if( this.$route.name === 'layout' )
      this.goTo('home')
  },

  watch: {}
};
</script>
